import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";

// Desktop header basket icon with the item count, shown on every page while the basket has items.
// Phones use the bottom bar (MobileBasketBar) instead.

const BasketNavButton = ({ className = "", onClick }) => {
  const { cartItems } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const count = cartItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);

  if (count === 0) return null;

  return (
    <button
      type="button"
      aria-label={count > 0 ? `Basket, ${count} item${count === 1 ? "" : "s"}` : "Basket"}
      onClick={() => {
        if (onClick) onClick();
        // On the order page the basket is already there: just bring it into view
        const basket = document.querySelector(".basket-section");
        if (location.pathname.startsWith("/order-online") && basket) {
          basket.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        navigate("/order-online");
      }}
      className={`relative flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-full border border-white/20 bg-transparent text-white transition hover:border-brand-orange hover:text-brand-orange ${className}`}
    >
      <i className="fa-solid fa-bag-shopping text-[16px]" />
      {count > 0 && (
        <span className="absolute -right-1 -top-1 flex h-[20px] min-w-[20px] items-center justify-center rounded-full bg-brand-orange px-1 text-[11px] font-bold leading-none text-black">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
};

export default BasketNavButton;
